import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Session } from '../../structures/response/Session';
import { sessionClose, sessionCloseAll, sessionList } from '../../api/account';

export default function useSessionList(): {
  response: Session[];
  loading: boolean;
  closeSession: (id: number) => Promise<void>;
  closeAllSessions: () => Promise<void>;
} {
  const [response, setResponse] = useState<Session[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.removeItem('user');
    window.location.href = '/lk/#/signin';
  };

  async function getData() {
    setLoading(true);
    try {
      const r = await sessionList();
      setResponse(r);
    } catch (e) {
      console.log(e); // todo: remove this line
    }
    setLoading(false);
  }

  async function closeSession(id: number, isCurrent = false) {
    if (isCurrent) {
      handleSignOut();
    } else {
      await sessionClose(id);
    }
  }

  async function closeAllSessions() {
    await sessionCloseAll();
    handleSignOut();
  }

  useEffect(() => {
    getData();
  }, []);

  return { response, closeSession, closeAllSessions, loading };
}
